import React, { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
import { Chip, Divider, Menu, MenuItem, TextField } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import Button from '@mui/material/Button';
import '@fontsource/lato';
import { DeleteDotPhraseModal } from '~/components/dotPhrases/DeleteDotPhraseModal';
import { getDotPhrasesRequest } from "~/api/dotPhrases/getDotPhrasesRequest";
import axios from "axios";
import getCaretCoordinates from "textarea-caret";
export const DotPhraseMenu = (props) => {
    const { practiceId, userId, anchorEl, dotPosition, initialDotPhrases, dotPhraseSelected } = props;
    const [isOpen, setIsOpen] = useState(true);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState('');
    const [dotPhraseToEdit, setDotPhraseToEdit] = useState(null);
    const inputEl = useRef(null);
    const [searchInputValue, setSearchInputValue] = useState('');
    const [dotPhrases, setDotPhrases] = useState(initialDotPhrases);
    const [filteredDotPhrases, setFilteredDotPhrases] = useState(initialDotPhrases);
    const [newDotPhraseName, setNewDotPhraseName] = useState('');
    const [newDotPhraseContent, setNewDotPhraseContent] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    // Calculate the pixel position of the dot
    const getDotCoordinates = () => {
        if (!anchorEl)
            return { top: 0, left: 0 };
        const textarea = anchorEl;
        const coords = getCaretCoordinates(textarea, dotPosition);
        const textareaRect = textarea.getBoundingClientRect();
        return {
            top: textareaRect.top + coords.top + 150,
            left: textareaRect.left + coords.left + 80
        };
    };
    const dotCoords = getDotCoordinates();
    useEffect(() => {
        console.log(practiceId);
        console.log(userId);
        getDotPhrases();
    }, []);
    useEffect(() => {
        if (!newDotPhraseContent || newDotPhraseContent.trim() === '') {
            setIsButtonDisabled(true);
        }
        else {
            setIsButtonDisabled(false);
        }
    }, [newDotPhraseContent]);
    const getDotPhrases = async () => {
        const dotPhrases = await getDotPhrasesRequest();
        console.log('Here are dot phrases: ');
        console.log(dotPhrases);
        setDotPhrases(dotPhrases.dotPhrases);
        setFilteredDotPhrases(dotPhrases.dotPhrases);
    };
    useEffect(() => {
        if (isOpen) {
            // Blur any focused elements in the menu and refocus the textarea
            setTimeout(() => {
                if (anchorEl) {
                    anchorEl.focus();
                }
            }, 0);
        }
    }, [isOpen, anchorEl]);
    const handleCloseMenu = () => {
        setIsOpen(false);
    };
    const handleDotPhraseClick = async (dotPhrase) => {
        console.log('handle click');
        console.log(dotPhrase);
        dotPhraseSelected(dotPhrase.dotPhraseContent);
        setIsOpen(false);
    };
    const handleSaveDotPhrase = async () => {
        if (dotPhraseToEdit) {
            await axios.post('/api/dotPhrases/editDotPhrase', {
                dot_phrase_id: dotPhraseToEdit.id,
                dot_phrase_name: newDotPhraseName,
                dot_phrase_content: newDotPhraseContent,
            });
            dotPhraseToEdit.dotPhraseName = newDotPhraseName;
            dotPhraseToEdit.dotPhraseContent = newDotPhraseContent;
            //
            // dotPhraseUpdated(dotPhraseToEdit);
            //
            //
            setIsEditOpen(false);
            setNewDotPhraseContent('');
            setDotPhraseToEdit(null);
            //
            // alert('Dot phrase updated. Please reload the page');
            //
            // window.location.reload();
        }
        else {
            // Add a new label
            const response = await axios.post('/api/dotPhrases/addDotPhrase', {
                dot_phrase_name: newDotPhraseName,
                dot_phrase_content: newDotPhraseContent,
                practice_id: practiceId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const dotPhrase = response.data.data.new_dot_phrase;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            dotPhrase.dotPhraseName = response.data.data.new_dot_phrase.dot_phrase_name;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            dotPhrase.dotPhraseContent = response.data.data.new_dot_phrase.dot_phrase_content;
            dotPhrases.push(dotPhrase);
            setDotPhrases(dotPhrases);
            setIsEditOpen(false);
            setNewDotPhraseName('');
            setNewDotPhraseContent('');
            setDotPhraseToEdit(null);
        }
    };
    const handleSearchInputChange = (value) => {
        setSearchInputValue(value);
        if (value === '') {
            setFilteredDotPhrases(dotPhrases);
        }
        else {
            const newFilteredValues = dotPhrases.filter((dotPhrase) => dotPhrase.dotPhraseName.toLowerCase().includes(value.toLowerCase()));
            setFilteredDotPhrases(newFilteredValues);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { id: "dotphrase-menu", anchorReference: "anchorPosition", anchorPosition: { top: dotCoords.top, left: dotCoords.left }, open: isOpen, onClose: handleCloseMenu, disableAutoFocus: true },
            React.createElement(TextField, { onKeyDown: (event) => event.stopPropagation(), autoFocus: false, type: "search", style: { marginLeft: '10px', marginRight: '10px', marginBottom: '5px' }, label: "Search Dot Phrases", variant: "outlined", size: "small", value: searchInputValue, onChange: (val) => handleSearchInputChange(val.currentTarget.value) }),
            React.createElement("div", { style: { maxHeight: '150px', overflow: 'scroll' } }, filteredDotPhrases.map((dotPhrase) => (React.createElement(MenuItem, { onMouseEnter: () => setHoveredItem(dotPhrase.dotPhraseName), onMouseLeave: () => setHoveredItem('') },
                React.createElement(Chip, { size: 'small', color: 'primary', variant: 'filled', label: dotPhrase.dotPhraseName, style: { padding: 5, backgroundColor: '#00000013', fontFamily: 'Barlow', fontWeight: '600', borderRadius: 6, color: '#000000DE' }, onClick: () => handleDotPhraseClick(dotPhrase) }),
                React.createElement("div", { style: { float: 'right', marginLeft: 'auto' } }, hoveredItem === dotPhrase.dotPhraseName &&
                    React.createElement(Button, { style: { padding: '0', minWidth: '0px', minHeight: '0px', height: '15px', width: '15px', borderRadius: '50%' }, variant: 'contained', onClick: () => {
                            setDotPhraseToEdit(dotPhrase);
                            setIsEditOpen(true);
                            setNewDotPhraseContent(dotPhrase.dotPhraseContent);
                            setNewDotPhraseName(dotPhrase.dotPhraseName);
                            // setNewLabelValue(label.labelName);
                            // setPopperAnchorEl(event.currentTarget);
                        } },
                        React.createElement(Edit, { style: { fontSize: 'x-small' } }))))))),
            React.createElement(Divider, null),
            React.createElement(MenuItem, { ref: inputEl, onClick: () => {
                    setIsEditOpen(true);
                    // setPopperAnchorEl(event.currentTarget);
                } },
                React.createElement("div", { style: { width: '100%', marginLeft: 'auto', marginRight: 'auto' } },
                    React.createElement(Add, { style: { color: '#00000054', fontFamily: 'Barlow' } }),
                    " Add Dot Phrase"))),
        isEditOpen &&
            React.createElement(Menu, { onClose: () => {
                    setIsEditOpen(false);
                    setDotPhraseToEdit(null);
                }, anchorEl: inputEl.current, open: isEditOpen, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                } },
                React.createElement("div", { style: { width: '100%', paddingLeft: '10px', paddingBottom: '10px', color: 'black', fontSize: 16, fontFamily: 'Barlow', fontWeight: 600 } }, dotPhraseToEdit ? 'Edit Dot Phrase' : 'Add Dot Phrase'),
                React.createElement(Divider, null),
                React.createElement("div", { style: { display: 'grid' } },
                    React.createElement("input", { onKeyDown: (event) => {
                            const input = event.currentTarget; // Use currentTarget instead of target
                            const cursorPosition = input.selectionStart;
                            // Prevent deleting the first character if it would remove the period
                            if ((event.key === 'Backspace' && cursorPosition !== null && cursorPosition <= 1) ||
                                (event.key === 'Delete' && cursorPosition === 0)) {
                                event.preventDefault();
                            }
                            // Keep your existing stopPropagation
                            event.stopPropagation();
                        }, style: { margin: '10px', padding: '10px', width: '200px', height: '25px', borderWidth: '1px', borderColor: '#B9B9B9', borderRadius: '4px' }, placeholder: '.Name Your Dot Phrase', defaultValue: dotPhraseToEdit ? dotPhraseToEdit.dotPhraseName : undefined, onChange: (event) => {
                            let value = event.currentTarget.value;
                            // If the value doesn't start with a period, add one
                            if (value.length > 0 && !value.startsWith('.')) {
                                value = '.' + value;
                                // Update the input value directly to include the period
                                event.currentTarget.value = value;
                            }
                            setNewDotPhraseName(value);
                        } }),
                    React.createElement("textarea", { onKeyDown: (event) => event.stopPropagation(), style: {
                            verticalAlign: 'top',
                            margin: '10px',
                            overflowY: 'scroll',
                            height: '85px',
                            padding: '10px',
                            width: '200px',
                            borderWidth: '1px',
                            borderColor: '#B9B9B9',
                            borderRadius: '4px'
                        }, placeholder: 'Please add your Dot Phrase here', defaultValue: dotPhraseToEdit ? dotPhraseToEdit.dotPhraseContent : undefined, onChange: (val) => setNewDotPhraseContent(val.currentTarget.value) })),
                React.createElement(Divider, null),
                React.createElement("div", { style: { padding: '10px' } },
                    React.createElement(Delete, { style: { color: '#D32F2F', cursor: 'pointer' }, onClick: () => {
                            if (dotPhraseToEdit) {
                                setIsDeleteOpen(true);
                            }
                        } }),
                    React.createElement("div", { className: "float-right" },
                        React.createElement(Button, { style: { marginRight: '10px', fontFamily: 'Barlow', fontWeight: 700, fontSize: 13 }, size: "small", variant: "outlined", color: "primary", onClick: () => {
                                setIsEditOpen(false);
                                setDotPhraseToEdit(null);
                            } }, "Cancel"),
                        React.createElement(Button, { disabled: isButtonDisabled, style: { fontFamily: 'Barlow', fontWeight: 700, fontSize: 13 }, size: "small", variant: "contained", color: "primary", onClick: handleSaveDotPhrase }, "Save")))),
        isDeleteOpen && (React.createElement(DeleteDotPhraseModal, { onRequestClose: () => {
                dotPhrases.filter((dotPhrase) => dotPhrase.id !== dotPhraseToEdit?.id);
                setIsDeleteOpen(false);
                setDotPhraseToEdit(null);
                setIsEditOpen(false);
            }, dotPhraseToEdit: dotPhraseToEdit }))));
};
